// The customer-facing words for TikTok sounds and songs, as PHP's term() (app/helpers.php) gives them: the page sets
// window.tokchartTerms from resources/lang/en/terms.php (partials/terms-script). term('sounds') → "audios",
// term('Sound') → "Audio", term('sounds', 25) → "25 audios".
const FALLBACK = { sound: 'audio', sounds: 'audios', song: 'song', songs: 'songs' };

export function term(key, count = null) {
    const words = { ...FALLBACK, ...(window.tokchartTerms ?? {}) };
    let lower = key.toLowerCase();
    if (count !== null) lower = lower.replace(/s$/, '') + (Number(count) === 1 ? '' : 's');
    let word = words[lower] ?? lower;
    if (key !== key.toLowerCase()) word = word.charAt(0).toUpperCase() + word.slice(1);

    return count === null ? word : `${Number(count).toLocaleString('en')} ${word}`;
}
